'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const DirectoryDiffTree = styled.div``;

export const DirectoryNode = styled.div<{ $selected?: boolean }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  font-weight: ${(props) => (props.$selected ? '800' : 'normal')};
  cursor: pointer;

  &:hover {
    background-color: ${colors.secondary.lightGray1};
  }

  & > div {
    display: flex;
    align-items: center;
  }

  & .folder-icon {
    color: ${(props) => (props.$selected ? colors.secondary.darkGray1 : colors.secondary.mediumGray)};
  }
`;
